/*
 * @bot-written
 *
 * WARNING AND NOTICE
 * Any access, download, storage, and/or use of this source code is subject to the terms and conditions of the
 * Full Software Licence as accepted by you before being granted access to this source code and other materials,
 * the terms of which can be accessed on the Codebots website at https://codebots.com/full-software-licence. Any
 * commercial use in contravention of the terms of the Full Software Licence may be pursued by Codebots through
 * licence termination and further legal action, and be required to indemnify Codebots for any loss or damage,
 * including interest and costs. You are deemed to have accepted the terms of the Full Software Licence on any
 * access, download, storage, and/or use of this source code.
 *
 * BOT WARNING
 * This file is bot-written.
 * Any changes out side of "protected regions" will be lost next time the bot makes any changes.
 */
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import MustardManagementPrimaryGenreReferenceManyToMany from '../Security/Acl/MustardManagementPrimaryGenreReferenceManyToMany';
// % protected region % [Add any further imports here] off begin
// % protected region % [Add any further imports here] end

export interface ISecondaryGenrePrimaryGenreAttributes extends IModelAttributes {
	secondaryGenreId: string;
	primaryGenreId: string;

	secondaryGenre: Models.GenreEntity | Models.IGenreEntityAttributes;
	primaryGenre: Models.GenreEntity | Models.IGenreEntityAttributes;
	// % protected region % [Add any custom attributes to the interface here] off begin
	// % protected region % [Add any custom attributes to the interface here] end
}

@entity('SecondaryGenrePrimaryGenre')
export default class SecondaryGenrePrimaryGenre
	extends Model
	implements ISecondaryGenrePrimaryGenreAttributes {
	public static acls: IAcl[] = [
		new MustardManagementPrimaryGenreReferenceManyToMany(),
		// % protected region % [Add any further ACL entries here] off begin
		// % protected region % [Add any further ACL entries here] end
	];

	@observable
	@attribute()
	public secondaryGenreId: string;

	@observable
	@attribute()
	public primaryGenreId: string;

	@observable
	@attribute({ isReference: true })
	public secondaryGenre: Models.GenreEntity;

	@observable
	@attribute({ isReference: true })
	public primaryGenre: Models.GenreEntity;
	// % protected region % [Add any custom attributes to the model here] off begin
	// % protected region % [Add any custom attributes to the model here] end

	constructor(attributes?: Partial<ISecondaryGenrePrimaryGenreAttributes>) {
		// % protected region % [Add any extra constructor logic before calling super here] off begin
		// % protected region % [Add any extra constructor logic before calling super here] end

		super(attributes);

		if (attributes) {
			if (attributes.secondaryGenreId) {
				this.secondaryGenreId = attributes.secondaryGenreId;
			}
			if (attributes.primaryGenreId) {
				this.primaryGenreId = attributes.primaryGenreId;
			}

			if (attributes.secondaryGenre) {
				if (attributes.secondaryGenre instanceof Models.GenreEntity) {
					this.secondaryGenre = attributes.secondaryGenre;
					this.secondaryGenreId = attributes.secondaryGenre.id;
				} else {
					this.secondaryGenre = new Models.GenreEntity(attributes.secondaryGenre);
					this.secondaryGenreId = this.secondaryGenre.id;
				}
			} else if (attributes.secondaryGenreId !== undefined) {
				this.secondaryGenreId = attributes.secondaryGenreId;
			}

			if (attributes.primaryGenre) {
				if (attributes.primaryGenre instanceof Models.GenreEntity) {
					this.primaryGenre = attributes.primaryGenre;
					this.primaryGenreId = attributes.primaryGenre.id;
				} else {
					this.primaryGenre = new Models.GenreEntity(attributes.primaryGenre);
					this.primaryGenreId = this.primaryGenre.id;
				}
			} else if (attributes.primaryGenreId !== undefined) {
				this.primaryGenreId = attributes.primaryGenreId;
			}
		}

		// % protected region % [Add any extra constructor logic after calling super here] off begin
		// % protected region % [Add any extra constructor logic after calling super here] end
	}

	// % protected region % [Add any further custom model features here] off begin
	// % protected region % [Add any further custom model features here] end
}
